import { Tab } from "@headlessui/react"
import { ArrowRightIcon } from "@heroicons/react/20/solid"

export function BuildHighlight({ title, description, tabs }) {
  return (
    <div className="bg-gray-100 py-12">
      <div className="mx-auto max-w-5xl p-8">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-4xl font-semibold tracking-tight text-balance text-gray-900 sm:text-5xl">
            {title}
          </h2>
          <p className="mt-4 text-lg font-medium text-pretty sm:text-xl/8">{description}</p>
        </div>

        {/* Build Highlights */}
        <div className="mt-8">
          <Tab.Group>
            {/* Highlight Preview Tabs */}
            <Tab.List className="grid w-full max-w-4xl grid-cols-2 justify-items-center gap-4 sm:flex sm:justify-center sm:space-x-4">
              {tabs.map((tab, index) => (
                <Tab
                  key={index}
                  className={({ selected }) =>
                    `rounded-lg p-4 drop-shadow-lg ${
                      selected ? "bg-black text-white" : "bg-white text-black"
                    }`
                  }
                >
                  <div className="flex flex-col items-center">
                    <img
                      src={tab.image}
                      alt={tab.title}
                      className="h-20 w-32 rounded-t-lg object-cover"
                    />
                    <h3 className="text-xs font-semibold sm:text-lg">{tab.title}</h3>
                    <p className="font-mono text-xs sm:text-base">{tab.price}</p>
                  </div>
                </Tab>
              ))}
            </Tab.List>

            {/* Selected Highlight Information */}
            <Tab.Panels className="sm:mt-4">
              {tabs.map((tab, index) => (
                <Tab.Panel key={index} className="flex flex-col items-center text-center">
                  {/* Image */}
                  <div className="relative my-6 flex w-3/4 justify-center">
                    <img
                      src={tab.centerImage}
                      alt={tab.centerImageAlt}
                      className="h-full w-full object-contain object-center"
                    />
                  </div>

                  {/* Features */}
                  <div className="my-4 grid grid-cols-3 gap-4 sm:grid-cols-6 sm:gap-8">
                    {tab.features.map((feature, idx) => (
                      <div key={idx} className="flex flex-col items-center pr-2 sm:pr-4">
                        <img
                          src={feature.image}
                          alt={feature.title}
                          className="mb-2 h-8 w-8 object-contain sm:h-24 sm:w-24"
                        />
                        <div className="border-l border-gray-300">
                          <h3 className="ml-1 font-mono text-sm sm:text-lg">{feature.title}</h3>
                        </div>
                        <p className="font-mono text-xs text-gray-600 sm:text-base">
                          {feature.price}
                        </p>
                      </div>
                    ))}
                  </div>

                  {/* Buttons */}
                  <div className="flex justify-center space-x-4 pt-4">
                    <a
                      href={tab.link}
                      className="inline-flex items-center gap-x-1.5 rounded-full border border-black bg-white px-4 text-xs text-black sm:text-base"
                    >
                      Explore Van Spotlight <ArrowRightIcon className="h-4 w-4 stroke-black" />
                    </a>
                    <a
                      href={tab.link}
                      className="inline-flex items-center gap-x-1.5 rounded-full bg-black px-4 text-xs text-white sm:inline-flex sm:text-base"
                    >
                      Our Build Process <ArrowRightIcon className="h-4 w-4 stroke-white" />
                    </a>
                  </div>
                </Tab.Panel>
              ))}
            </Tab.Panels>
          </Tab.Group>
        </div>
      </div>
    </div>
  )
}
